//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "loader",
  props: ["loaded", "main"],
};
